import { LeafletCurveOptions } from './models/leaflet-curve-options.model';

import { Component, Input, DoCheck, IterableDiffers } from '@angular/core';

import * as L from 'leaflet';
import { LeafletBlockComponent } from '../leaflet-block-component.interface';

@Component({
    selector: 'leaflet-curve',
    template: '',
    standalone: false
})
export class LeafletCurveComponent implements LeafletBlockComponent, DoCheck { //extends LeafletPathComponent {
	@Input() public name: string;
	@Input() public isDefault: boolean = true;
	@Input() public includeInOverlays: boolean = true;

	private _data: {
		path: any[],
		options: LeafletCurveOptions
	}[];
	@Input()
	public get data(): {
		path: any[],
		options: LeafletCurveOptions
	}[] { return this._data; }
	public set data(
		value: {
			path: any[],
			options: LeafletCurveOptions
		}[]
	) {
		this._data = value;

		this.updateLayerGroup();
	}

	private _layerGroup: any;

	public updateLayerGroup(additively: boolean = false): void {
		if (!this._layerGroup) {
			return;
		}

		if (!additively) {
			this._layerGroup.clearLayers();
		}

		let markers = [];


		for (let a = 0; a < markers.length; a++) {
			this._layerGroup.addLayer(markers[a]);
		}
	}

	public initialize(layerGroup: L.LayerGroup, map: L.Map) {
		this._layerGroup = layerGroup;

		this.updateLayerGroup();
	}

	private iterableDiffer: any;

	constructor(private _iterableDiffers: IterableDiffers) {
    this.iterableDiffer = this._iterableDiffers.find([]).create(null);
	}

	ngDoCheck(): void {
		let changes = this.iterableDiffer.diff(this._data);
    
		if (changes) {
			console.log('Changes detected!', this._data);

			this.updateLayerGroup();
		}
	}
}
